import React from 'react';
import moment from 'moment';
import { Actions } from '../actions';

const Timer = ({time}) => <b>{moment.utc(time).format('mm:ss')}</b>;

class Countdown extends React.Component {
    constructor(props) {
        super(props);

        const target = props.startTime.add(props.length, 'minutes');

        this.state = {
            time: target.diff(moment()),
        }

        this.timer = setInterval(() => {
            const timeLeft = target.diff(moment());
            if (timeLeft <= 0) {
                clearInterval(this.timer);
                Actions.setTimeIsUp(true);
            }

            this.setState({
                time: timeLeft,
            });
        }, 1000);
    };

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        return (
            <div className="countdown">
                <p>Pidämme valittua aikaa varattuna vielä <Timer time={this.state.time} /></p>
            </div>
        );
    };
}

export default Countdown;



/** WEBPACK FOOTER **
 ** /home/rengasturku/nettivanne/nettivanne.git/nettivanne/static/nettivanne/webshop/js/tire-change/components/Countdown.js
 **/